declare global {
  namespace NodeJS {
    interface ProcessEnv {
      REACT_APP_JETPACK_USE_SSL_OVERRIDE: string;
      NODE_ENV: "development" | "production";
    }
  }
}

export const getEnv = (name: string, defaultValue: string): string => {
  const value = process.env[name];
  return typeof value === "undefined" ? defaultValue : value;
};

export const getEnvAsInt = (name: string, defaultValue: number): number => {
  return parseInt(getEnv(name, `${defaultValue}`));
};

export const getEnvAsBool = (name: string, defaultValue: boolean): boolean =>
  !!JSON.parse(getEnv(name, `${defaultValue}`));
